appSocial.component('leaderInfo', {
    templateUrl: 'widgets/leader-detail/components/leader-info/LeaderInfoComponent.html',
    bindings: {
        trader: '<'
    },
    controller: class LeaderInfoComponent {
        constructor(
            SocialUserService,
            SocialLocaleService,
            SocialFavoriteService,
            SocialPortfolioService,
            SocialUtils,
            SocialConstants,
            $ionicLoading
        ) {

            /**
             * @type {SocialUserService}
             */
            this.userService = SocialUserService;

            /**
             * @type {SocialFavoriteService}
             */
            this.favoriteService = SocialFavoriteService;

            /**
             * @type {SocialPortfolioService}
             */
            this.portfolioService = SocialPortfolioService;

            /**
             * @type {SocialUtils}
             */
            this.utils = SocialUtils;

            this.translation = SocialLocaleService.translation;

            this.countries = SocialConstants.countries;

            this.user = this.userService.get();

        }


        $onInit() {
            this.setCountry();
        }

        setCountry() {
            const country = this.countries
                .find((_country) => _country.code.toLowerCase() === this.trader.country.toLowerCase());
            this.countryCode = !!country && country.code.toLowerCase();
            this.countryName = !!country && country.country;
        }
    }
})
